import { render } from 'preact';
import { ChatWidget } from '../components/ChatWidget';
import styles from '../styles/widget.css?raw';

const FONT_LINK_ID = 'sophia-ai-cairo-font';
const FONT_HREF = 'https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap';

/**
 * Mounts the widget into a Shadow DOM on the given host, isolating its CSS from
 * the Woodmart storefront (and vice versa). The Cairo @font-face must live in
 * the document head — fonts resolve at the document level, not inside the
 * shadow tree — while all component styles are scoped to the shadow root.
 */
export function mountWidget(host: HTMLElement, apiBaseUrl: string): void {
  ensureCairoFont();

  const shadow = host.shadowRoot ?? host.attachShadow({ mode: 'open' });

  const style = document.createElement('style');
  style.textContent = styles;
  shadow.appendChild(style);

  const mountPoint = document.createElement('div');
  shadow.appendChild(mountPoint);

  render(<ChatWidget apiBaseUrl={apiBaseUrl} />, mountPoint);
}

function ensureCairoFont(): void {
  if (document.getElementById(FONT_LINK_ID) !== null) {
    return;
  }

  const link = document.createElement('link');
  link.id = FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = FONT_HREF;
  document.head.appendChild(link);
}
